import { ErrorMessage } from '@hookform/error-message'
import { FieldErrors, Path, FieldValues } from 'react-hook-form'
import styles from './validation.module.scss'

type FieldErrorMessageProps<T extends FieldValues> = {
  name: Path<T>
  errors: FieldErrors<T>
}

export function FieldErrorMessage<T extends FieldValues>({
  errors,
  name
}: FieldErrorMessageProps<T>) {
  return (
    <ErrorMessage
      errors={errors}
      name={name as any}
      render={({ message }) => (
        <p className={styles.ErrorMessage} role="alert">
          {message}
        </p>
      )}
    />
  )
}
